// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__UhrJr","title":"Header_title__24eaC","side":"Header_side__3HHac"};